export default __webpack_public_path__ + "static/media/02.f164d71b.jpg";